import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { MdEdit, MdDelete } from "react-icons/md";
import { FaExclamationTriangle } from "react-icons/fa";
import { HiRefresh } from "react-icons/hi";
import { useSelector } from "react-redux";
import { UserDetails } from "../redux/userSlice";
import LoaderModal from "../components/ModalLoader/LoaderModal";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import tblarrrow from "../assets/images/tblarrrow.svg";
import { Pagination } from "react-bootstrap";
const AdminDashborad = () => {
  const [showModal, setShowModal] = useState(false);
  const [accountModal, setaccountModal] = useState(false);
  const APi_Url = process.env.REACT_APP_ENIGMA_API;
  const [adminAddUser, setadminAddUser] = useState();
  const [adminAddUserDocuSign,setAdminAddUserDocuSign]=useState();
  const [userList, setUserList] = useState([]);
  const [sortUserList, setSortUserList] = useState([]);

  const getAllDocuSign = async () => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/account/get-all-docusign`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        console.log(
          "resposne get all docusign list ",
          response?.data?.response[0]
        );
       
        setadminAddUser(response?.data?.response[0].adminAddUser);
        setAdminAddUserDocuSign(response?.data?.response[0].adminAddUserDocuSign);

        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };

  const fetchAllUsers = async () => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/admin/Get-All-Users`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        // console.log("resposne list ", response?.data?.response);
        setUserList(response?.data?.response);
        setSortUserList(response?.data?.response);
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };
  useEffect(() => {
    fetchAllUsers();
    getAllDocuSign();
  }, []);

  // acoount create validation and from submit start
  const initialValues = {
    userName: "",
    firstname:"",
    lastname:"",
    adminAddUserDocuSign:adminAddUserDocuSign?adminAddUserDocuSign:false
  };

  const validationSchema = Yup.object({
    userName: Yup.string()
      .email("Invalid email format")
      .required("Email is Required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Email domain must be a valid domain"
      ),
      firstname: Yup.string().when("adminAddUserDocuSign", {
        is: true, // When adminAddUserDocuSign is true
        then: (schema) =>
          schema
            .min(1, "First Name must be at least 1 character")
            .test(
              "no-spaces",
              "First Name must not contain only spaces or excessive spaces",
              (value) => value && !/^\s+$/.test(value) && !/\s\s+/.test(value)
            )
            .required("First Name is required"),
        otherwise: (schema) => schema.notRequired(), // When false or undefined
      }),
      lastname: Yup.string().when("adminAddUserDocuSign", {
        is: true, // When adminAddUserDocuSign is true
        then: (schema) =>
          schema
            .min(1, "Last Name must be at least 1 character")
            .test(
              "no-spaces",
              "Last Name must not contain only spaces or excessive spaces",
              (value) => value && !/^\s+$/.test(value) && !/\s\s+/.test(value)
            )
            .required("Last Name is required"),
        otherwise: (schema) => schema.notRequired(), // When false or undefined
      }),
  
  });
  const adminMailEsignature = async (value) => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/auth/send-mail-esignature-admin/${value.userName}/${value.firstname}/${value.lastname}`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("resposne profile send-mail-esignature-for-admin", response.data);
      if ( response.data.statusCode == 200 && response.data.success==true) {
        // console.log("resposne profile ", response.data.response);
        // setUserData(response?.data?.response);
        toast.success(response.data.response);
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };

  const adminUpdateEsignature = async (email) => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/auth/update-mail-esignature-for-admin/${email}`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("resposne profile send-mail-esignature-for-admin", response.data);
      if ( response.data.statusCode == 200 && response.data.success==true) {
        // console.log("resposne profile ", response.data.response);
        // setUserData(response?.data?.response);
        toast.success(response.data.response);
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };
  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    setShowModal(true);
    // console.log("values",values.userName)
    const email = values.userName;
    const token =
      "4bd64e434292798ff43ae9707e0fb0625ec67333d6b283baa00dde26de01f8b0";
    //  "#accountModal".modal("hide");
    // isDeleted: true,

    try {
      const response = await axios.get(
        `${APi_Url}api/auth/check-registration/${email}/${token}`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("resposne", response.data.success);
      // console.log("message", response.data.response);

      if (response?.data.statusCode == 200) {
        if (response?.data.massege == "User Already exist.") {
          toast.error("User Already exist.");
          setShowModal(false);
        
        } else if (response?.data.massege == "User registered successfully") {
          setShowModal(false);
          toast.success("User registered successfully");
          if(adminAddUserDocuSign){
          adminMailEsignature(values);
          }
          else{
            adminUpdateEsignature(email);
          }
        }
      }

      // toast.success("Successfully User Created");
      // showAccounts();
      setaccountModal(false);
      resetForm();
      fetchAllUsers();
    } catch (error) {
      console.error("Error ", error);
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const [userId, setUserId] = useState();
  const [userName, setUserName] = useState();
  const deleteUserModal = (data) => {
    setDeleteModal(true);
    setUserId(data.userId);
    setUserName(data.userName);
  };
  const deleteUser = async () => {
    try {
      const response = await axios.post(
        `${APi_Url}api/auth/raw-delete-user/${userId}`,
        {},
        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("profile update successfully:", response.data.response);

      toast.success("User deleted successfully");
      setUserId();
      setUserName();
      fetchAllUsers();
      setDeleteModal(false);
    } catch (error) {
      console.error("Error uploading image:", error);
      setDeleteModal(false);
    }
  };

  // edit user profile section start

  const userDetails = useSelector(UserDetails);
  const token = userDetails?.token;
  const [editProfileStatus, setEditProfileStatus] = useState(false);
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [userData, setUserData] = useState();

  const EditModalFunction = (data) => {
    setEditProfileStatus(true);
    setUserId(data.userId);
    fetchUserDetails(data.userId);
  };

  const fetchUserDetails = async (id) => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/Profile/Get_Profile/${id}`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        // console.log("resposne profile ", response.data.response);
        setUserData(response?.data?.response);
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };
  // /
 

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const profileuploadinitialValues = {
    FirstName: userData?.firstName || "",
    LastName: userData?.lastName || "",
    PhoneNumber: userData?.phoneNumber || "",
  };

  const profileuploadvalidationSchema = Yup.object({
    FirstName: Yup.string()
      .min(1, "First Name must be at least 1 characters")
      .test(
        "no-spaces",
        "First Name must not contain only spaces or excessive spaces",
        (value) => {
          return value && !/^\s+$/.test(value) && !/\s\s+/.test(value);
        }
      )
      .required("First Name is Required"),
    LastName: Yup.string()
      .min(1, "Last Name must be at least 1 characters")
      .test(
        "no-spaces",
        "Last Name must not contain only spaces or excessive spaces",
        (value) => {
          return value && !/^\s+$/.test(value) && !/\s\s+/.test(value);
        }
      )
      .required("Last Name is Required"),
    PhoneNumber: Yup.string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Phone number is Required")
      .min(10, "Phone number too short")
      .max(10, "Phone number too long"),
  });

  const handelProfileUpload = async (values, { setSubmitting, resetForm }) => {
    const data = {
      userId: userId,
      ...values,
    };
    try {
      const response = await axios.post(
        `${APi_Url}api/Profile/update-profile`,
        data,
        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("profile update successfully:", response.data.response);
      resetForm();
      toast.success("User profile update successfully");
      setUserData();
      fetchAllUsers();
      setEditProfileStatus(false);
    } catch (error) {
      console.error("Error uploading image:", error);
      setEditProfileStatus(false);
    }
  };

  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'

  const ResendPassword = async (values) => {
    // console.log("values",values.userName)
    const id = values.userId;
    // const token =
    //   "4bd64e434292798ff43ae9707e0fb0625ec67333d6b283baa00dde26de01f8b0";
    // //  "#accountModal".modal("hide");
    // // isDeleted: true,

    try {
      const response = await axios.post(
        `${APi_Url}api/admin/Resend-Password/${id}`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      console.log("resposne", response);

      toast.success("Successfully resend password");

      fetchAllUsers();
    } catch (error) {
      console.error("Error ", error);
    }
  };
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  // table Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default items per page




  // Calculate the number of pages
  const totalPages = itemsPerPage === 'All' ? 1 : Math.ceil(sortUserList.length / itemsPerPage);

  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Determine current items based on itemsPerPage
  const currentItems = itemsPerPage === 'All' ? sortUserList : sortUserList.slice(indexOfFirstItem, indexOfLastItem);





  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const userSort = () => {
    const sortedData = [...userList];
    sortedData.sort((a, b) => {
      if (sortOrder === "asc") {
        return a.userId - b.userId; // Ascending order
      } else {
        return b.userId - a.userId; // Descending order
      }
    });
    setSortUserList(sortedData);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc"); // Toggle sort order
  };

  const userSortName = (type) => {
    const sortedData = [...userList];
    sortedData.sort((a, b) => {
      const nameA = a[type].toLowerCase();
      const nameB = b[type].toLowerCase();

      if (sortOrder === "asc") {
        return nameA.localeCompare(nameB); // Ascending order
      } else {
        return nameB.localeCompare(nameA); // Descending order
      }
    });
    setSortUserList(sortedData);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc"); // Toggle sort order
  };

  const ResendContract=async(data)=>{
// console.log(data);
// firstName,lastName,userEmail
setShowModal(true);
try {
  const response = await axios.get(
    `${APi_Url}api/auth/send-mail-esignature-admin/${data.userEmail}/${data.firstName}/${data.lastName}`,

    {
      headers: {
        Accept: "application/json",
        
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  console.log("response send email signature");
  
  if ( response.data.statusCode == 200 && response.data.success==true) {
    
    
    toast.success("Successfully resend contract");
    setShowModal(false);
  }
  else{
    setShowModal(false);
  }
} catch (error) {
  console.error("Error uploading image:", error);
  setShowModal(false);
}

  }

  return (
    <>
      <section className="dashbordsect">
        {/* <div className="hadformsect">
          <h2>User Register</h2>
        </div> */}
        <div className="row">
          <div className="col-lg-9"></div>
          {adminAddUser &&
          <div className="col-lg-3">
            <button
              className="add_accountbtn"
              onClick={() => {
                setaccountModal(true);
              }}
            >
              Add user
            </button>
          </div>}
        </div>

        {/* user Listing */}
        {sortUserList?.length > 0 ? (
          <div style={{ marginTop: "20px" }}>
            <div className="row custmrgbottom">
              <div className="col-9">
                <Pagination>
                  <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />

                  {Array.from({ length: totalPages }, (_, index) => {
                    const pageNumber = index + 1;

                    if (
                      pageNumber === 1 ||
                      pageNumber === totalPages ||
                      (pageNumber >= currentPage - 1 &&
                        pageNumber <= currentPage + 1)
                    ) {
                      return (
                        <Pagination.Item
                          key={pageNumber}
                          active={pageNumber === currentPage}
                          onClick={() => handlePageChange(pageNumber)}
                        >
                          {pageNumber}
                        </Pagination.Item>
                      );
                    }

                    if (
                      pageNumber === currentPage - 2 ||
                      pageNumber === currentPage + 2
                    ) {
                      return <Pagination.Ellipsis key={pageNumber} />;
                    }

                    return null;
                  })}

                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>

              <div className="col-3">
                <div className="filteritembtn">
                <DropdownButton
                  id="dropdown-basic-button"

                  title={itemsPerPage}

                >
                  <Dropdown.Item
                    onClick={() => {
                      setItemsPerPage(10);
                      setCurrentPage(1);
                    }}
                  >
                    10
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setItemsPerPage(100);
                      setCurrentPage(1);
                    }}
                  >
                    100
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setItemsPerPage('All');
                      setCurrentPage(1);
                    }}
                  >
                    All
                  </Dropdown.Item>
                </DropdownButton>
                </div>
                
              </div>
            </div>
            <div className="admin_table acunttablemainbox table-responsive border20 ">
              <table className="table table-borderless mb-0">
                <thead>
                  <tr>
                    <th scope="col">
                      Id
                      <span
                        className="shotricon"
                        onClick={() => {
                          userSort();
                        }}
                      >
                        <img src={tblarrrow} alt="tblarrrow" />
                      </span>
                    </th>
                    <th scope="col">
                      First Name
                      <span
                        className="shotricon"
                        onClick={() => {
                          userSortName("firstName");
                        }}
                      >
                        <img src={tblarrrow} alt="tblarrrow" />
                      </span>
                    </th>

                    <th scope="col">
                      Last Name
                      <span
                        className="shotricon"
                        onClick={() => {
                          userSortName("lastName");
                        }}
                      >
                        <img src={tblarrrow} alt="tblarrrow" />
                      </span>
                    </th>
                    <th scope="col">
                      User Email
                      <span
                        className="shotricon"
                        onClick={() => {
                          userSortName("userEmail");
                        }}
                      >
                        <img src={tblarrrow} alt="tblarrrow" />
                      </span>
                    </th>
                    <th scope="col">Phone Number</th>
                    <th scope="col">Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((data, index) => (
                    <tr key={index + 1}>
                      <td>{index + 1}</td>
                      <td>{capitalizeFirstLetter(data.firstName)}</td>
                      <td>{capitalizeFirstLetter(data.lastName)}</td>
                      <td>{data.userEmail}</td>
                      <td>{data.phoneNumber}</td>
                      <td>
                        <h5
                          className={
                            data.status == "Registered"
                              ? "register"
                              : "unregister"
                          }
                        >
                          {data.status}
                        </h5>
                      </td>
                      <td className="tooltd">
                        <MdEdit
                          onClick={() => {
                            EditModalFunction(data);
                          }}
                          style={{ cursor: "pointer" ,fontSize:'25px'}}
                        />
                        <MdDelete
                          onClick={() => {
                            deleteUserModal(data);
                          }}
                          style={{ cursor: "pointer",fontSize:'25px' }}
                        />
                        {/* <div className="tooltipico">
                        <div class="tooltip-container">
                          <span className="tooltipsvg">
                           
                          </span>
                          <div class="tooltip">Resend</div>
                        </div>
                      </div> */}
                        <HiRefresh
                          onClick={() => {
                            ResendPassword(data);
                          }}
                          style={{ cursor: "pointer",fontSize:'25px' }}
                        />
                        {!data.signStatus && data.firstName && data.lastName ?
                        <button className="add_accountbtn" style={{fontSize:'12px',margin:'0 5px',height:'35px'}} onClick={()=>{ResendContract(data)}} >Resend Contract</button>:null
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* <div className='showmorbtnbox'>
      {RiskLevel1_Data?.length > 4 ? (  <button class="highlightbutton" disabled="" onClick={handleToggle}> {showAll ? 'Show Less' : 'Show More'}</button>):""}
      </div> */}
            </div>
          </div>
        ) : null}

        {/* user listing end */}

        {/* user create modal */}
        <div
          className={`modal fade inputmodal ${accountModal ? "show" : ""}`}
          aria-hidden="true"
          style={{ display: accountModal ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1>New User</h1>
              </div>
              <div className="modal-body">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                  enableReinitialize
                >
                  {({ values, setFieldValue }) => (
                    <Form className="row needs-validation">
                      <div className="col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            User Email
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="email"
                              id="userName"
                              name="userName"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="userName"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>
                        {values.adminAddUserDocuSign &&
                      <>
                       <div className="row mb-3">
                       <label className="col-sm-5 col-form-label">
                         First Name
                       </label>
                       <div className="col-sm-7">
                         <Field
                           type="text"
                           id="firstname"
                           name="firstname"
                           placeholder="Input here"
                           className="form-control"
                         />
                         <ErrorMessage
                           name="firstname"
                           component="div"
                           className="error_msg"
                         />
                       </div>
                     </div>

                     {/* Last name */}

                  
                     <div className="row mb-3">
                       <label className="col-sm-5 col-form-label">
                         Last Name
                       </label>
                       <div className="col-sm-7">
                         <Field
                           type="text"
                           id="lastname"
                           name="lastname"
                           placeholder="Input here"
                           className="form-control"
                         />
                         <ErrorMessage
                           name="lastname"
                           component="div"
                           className="error_msg"
                         />
                       </div>
                     </div>
                     </>
                    }
                      </div>
                     

                      <div className="col-12">
                        <button className="btn kevlar_btn" type="submit">
                          Submit
                        </button>
                      </div>
                      <div className="col-12">
                        <button
                          className="btn kevlar_btn"
                          type="button"
                          onClick={() => {
                            setaccountModal(false);
                            setFieldValue("userName", "");
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        {/* user create modal end */}

        {/* user delete Modal start*/}
        <div
          className={`modal fade inputmodal ${deleteModal ? "show" : ""}`}
          aria-hidden="true"
          style={{ display: deleteModal ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body ">
                <div className="delete-modal">
                  <div className="delecte-icon">
                    <FaExclamationTriangle className="delete-modal-icon" />
                  </div>
                  <h2>Delete "{userName}"</h2>

                  <h5>
                    This will permanently delete "{userName}" from the system.
                    Are you sure?
                  </h5>

                  <div className="delete-button-section">
                    <button
                      onClick={() => {
                        setDeleteModal(false);
                        setUserId();
                        setUserName();
                      }}
                      className="delete-button"
                    >
                      No, Keep It.
                    </button>

                    <button
                      className="delete-button yes-button"
                      onClick={() => {
                        deleteUser();
                      }}
                    >
                      Yes, Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* user delete Modal end*/}

        {/* Modal for edit profile start */}
        <div
          className={`modal fade inputmodal ${editProfileStatus ? "show" : ""}`}
          aria-hidden="true"
          style={{ display: editProfileStatus ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1>Edit Profile</h1>
              </div>
              <div className="modal-body">
                <Formik
                  initialValues={profileuploadinitialValues}
                  validationSchema={profileuploadvalidationSchema}
                  onSubmit={handelProfileUpload}
                  enableReinitialize={true}
                >
                  {({ resetForm }) => (
                    <Form className="row needs-validation">
                      <div className="col-md-12">
                        {/* old password */}
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            First Name
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="text"
                              id="FirstName"
                              name="FirstName"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="FirstName"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>
                        {/* new password */}
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            Last Name
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="text"
                              id="LastName"
                              name="LastName"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="LastName"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>

                        {/* confirm password */}
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            Phone Number
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="number"
                              id="PhoneNumber"
                              name="PhoneNumber"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="PhoneNumber"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <button className="btn kevlar_btn" type="submit">
                          Submit
                        </button>
                      </div>
                      <div className="col-12">
                        <button
                          className="btn kevlar_btn"
                          type="button"
                          onClick={() => {
                            setEditProfileStatus(false);
                            setUserId();
                            setUserData();
                            resetForm();
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <LoaderModal show={showModal} />
      </section>
    </>
  );
};

export default AdminDashborad;
